import { render, staticRenderFns } from "./Head-protection-experts.vue?vue&type=template&id=d117923c&"
import script from "./Head-protection-experts.vue?vue&type=script&lang=js&"
export * from "./Head-protection-experts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports